export default __webpack_public_path__ + "static/media/763.b07121b6.png";